export default __webpack_public_path__ + "static/media/DentalFlakesDog.d62601b7.png";